<template>
  <div>
    <div
      v-if="loading"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 300px;
      "
    >
      <a-spin tip="Loading order details..." />
    </div>
    <div v-else class="order-details-container">
      <DetailsHeader :breadcrumbItems="orderDetailsBreadcrumbs">
        <div class="header-content">
          <div
            style="
              display: flex;
              flex-direction: column;
              gap: 20px;
              margin-bottom: 20px;
              margin-top: 20px;
            "
          >
            <p style="margin: 0">
              Order ID: {{ order && order.id ? order.id : "N/A" }}
            </p>
            <div>
              <span style="font-weight: bold; margin-right: 8px"
                >Invoice Linked:</span
              >
              <span
                @click="viewInvoice(order.invoiceResponse.id)"
                style="
                  color: #26a246;
                  cursor: pointer;
                  font-weight: bolder;
                  text-decoration: underline;
                  margin-right: 10px;
                "
              >
                {{ order.invoiceResponse.id }}
              </span>
              <StatusTag
                :status="order.invoiceResponse ? invoiceStatus[order.invoiceResponse.status] : 'Unknown'"
              />
            </div>
            
            <!-- Complete Order Button -->
            <div v-if="shouldShowCompleteButton" style="margin-top: 16px">
              <a-button
                type="primary"
                :loading="completeOrderLoading"
                @click="handleCompleteOrder"
                style="
                  background-color: #26a246;
                  border: none;
                  border-radius: 6px;
                  height: 40px;
                  font-weight: 600;
                  box-shadow: 0 2px 4px rgba(38,162, 70, 0.2);
                "
                icon="check-circle"
              >
                Complete Order
              </a-button>
            </div>
          </div>
        </div>
      </DetailsHeader>

      <div v-if="order" class="order-content">
        <a-row :gutter="[24, 24]">
          <!-- Order Information -->
          <a-col :span="12">
            <a-card
              style="
                border-radius: 16px;
                margin-bottom: 20px;
                padding: 0px 8px;
                min-height: 300px;
              "
            >
              <h1
                style="
                  font-size: 16px;
                  font-weight: 800;
                  color: #6b7280;
                  margin-bottom: 16px !important;
                "
              >
                Order Information
              </h1>

              <a-row :gutter="[16, 16]" style="margin: 20px auto !important">
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Order ID</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ order.id }}
                  </p>
                </a-col>
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Fulfillment Method</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ order.fulfilmentType || "N/A" }}
                  </p>
                </a-col>
              </a-row>

              <a-row :gutter="[16, 16]">
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Date Placed</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ formatDate(order.createdAt) }}
                  </p>
                </a-col>
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Sales Channel</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ order.channel || "N/A" }}
                  </p>
                </a-col>
              </a-row>

              <a-row :gutter="[16, 16]">
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Expected Delivery</p>
                  <p style="font-weight: bolder !important; color: #000">N/A</p>
                </a-col>
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Payment Terms</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{
                      order.invoiceResponse &&
                      order.invoiceResponse.customerPaymentTerms
                        ? order.invoiceResponse.customerPaymentTerms + " days"
                        : "N/A"
                    }}
                  </p>
                </a-col>
              </a-row>

              <a-row :gutter="[16, 16]">
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Delivery Method</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{
                      DeliveryMethodMap[order.invoiceResponse.deliveryMethod]
                    }}
                  </p>
                </a-col>
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Invoice Status</p>
                  <StatusTag
                    :status="
                      invoiceStatus[
                        order && order.invoiceResponse
                          ? order.invoiceResponse.status
                          : null
                      ] || 'Unknown'
                    "
                  />
                </a-col>
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Order Status</p>
                  <StatusTag
                    :status="orderStatusDisplay"
                  />
                </a-col>
              </a-row>
            </a-card>
          </a-col>

          <!-- Buyer Information -->
          <a-col :span="12">
            <a-card
              style="
                border-radius: 16px;
                margin-bottom: 20px;
                padding: 0px 8px;
                min-height: 300px;
              "
            >
              <h1
                style="
                  font-size: 16px;
                  font-weight: 800;
                  color: #6b7280;
                  margin-bottom: 16px !important;
                "
              >
                Buyer Information
              </h1>

              <div
                style="
                  display: flex;
                  align-items: start;
                  justify-content: space-between;
                "
              >
                <div style="display: flex; align-items: center; gap: 12px">
                  <a-avatar
                    size="large"
                    :style="{
                      backgroundColor: '#d1fae5',
                      verticalAlign: 'middle',
                      color: '#047857',
                    }"
                    class="avatar"
                  >
                    {{
                      getInitials(
                        order.invoiceResponse &&
                          order.invoiceResponse.customerBusinessName
                          ? order.invoiceResponse.customerBusinessName
                          : ""
                      )
                    }}
                  </a-avatar>
                  <div style="display: flex; flex-direction: column; gap: 8px">
                    <p style="font-weight: bolder !important; color: #000">
                      {{
                        order.invoiceResponse &&
                        order.invoiceResponse.customerBusinessName
                          ? order.invoiceResponse.customerBusinessName
                          : "N/A"
                      }}
                    </p>
                    <p style="color: #6b7280">
                      {{
                        order.invoiceResponse &&
                        order.invoiceResponse.customerBusinessType
                          ? order.invoiceResponse.customerBusinessType
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <a-row
                :gutter="[16, 16]"
                style="margin-top: 20px; margin-bottom: 20px"
              >
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Phone</p>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <i class="fa fa-phone-alt" style="color: #26a246"></i>
                    <p style="font-weight: bolder !important; color: #000">
                      {{
                        order.invoiceResponse &&
                        order.invoiceResponse.customerPhoneNumber
                          ? order.invoiceResponse.customerPhoneNumber
                          : "N/A"
                      }}
                    </p>
                  </div>
                </a-col>
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Address</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ getFullAddress(order.invoiceResponse) }}
                  </p>
                </a-col>
              </a-row>
            </a-card>
          </a-col>
        </a-row>

        <a-row :gutter="[24, 24]">
          <!-- Product Details -->
          <a-col :span="24">
            <a-card
              style="border-radius: 16px; margin-bottom: 20px; padding: 0px 8px"
            >
              <h1
                style="
                  font-size: 16px;
                  font-weight: 800;
                  color: #6b7280;
                  margin-bottom: 16px !important;
                "
              >
                Product Breakdown
              </h1>
              <a-table
                :columns="productColumns"
                :data-source="order.productDetails"
                :pagination="false"
              />
            </a-card>
          </a-col>

          <!-- Financial Summary -->
          <a-col :span="12">
            <a-card
              style="
                border-radius: 16px;
                margin-bottom: 20px;
                padding: 0px 8px;
                min-height: 290px;
              "
            >
              <h1
                style="
                  font-size: 16px;
                  font-weight: 800;
                  color: #6b7280;
                  margin-bottom: 16px !important;
                "
              >
                Financial Summary
              </h1>

              <a-row :gutter="[16, 16]" style="margin: 20px auto !important">
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Subtotal</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ formatAmount(order.invoiceResponse.totalOrderValue) }}
                  </p>
                </a-col>
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Discounts</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ formatAmount(order.invoiceResponse.discount) }}
                  </p>
                </a-col>
              </a-row>

              <a-row :gutter="[16, 16]">
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Total (Incl. Tax)</p>
                  <p style="font-weight: bolder !important; color: #000">
                    {{ formatAmount(order.invoiceResponse.discountedValue) }}
                  </p>
                </a-col>
                <a-col :span="12">
                  <p style="margin-bottom: 8px">Invoice Linked</p>
                  <span
                    v-if="order.invoiceResponse && order.invoiceResponse.id"
                    @click="viewInvoice(order.invoiceResponse.id)"
                    style="
                      color: #26a246;
                      cursor: pointer;
                      font-weight: bolder;
                      text-decoration: underline;
                    "
                  >
                    {{ order.invoiceResponse.id }}
                  </span>
                  <span v-else>No</span>
                </a-col>
              </a-row>
            </a-card>
          </a-col>

          <!-- Activity Timeline -->
          <a-col :span="12">
            <a-card
              style="
                border-radius: 16px;
                margin-bottom: 20px;
                padding: 0px 8px;
                min-height: 290px;
              "
            >
              <h1
                style="
                  font-size: 16px;
                  font-weight: 800;
                  color: #6b7280;
                  margin-bottom: 16px !important;
                "
              >
                Activity Timeline
              </h1>
              <a-timeline style="margin: 20px auto !important">
                <a-timeline-item color="green">
                  <b>Order created</b>
                  <div style="color: #6b7280">
                    {{ formatDate(order.createdAt) }}
                  </div>
                </a-timeline-item>
                <a-timeline-item color="green">
                  <b>Order approved</b>
                  <div style="color: #6b7280">
                    {{ formatDate(order.invoiceResponse.createdAt) }}
                  </div>
                </a-timeline-item>
                <a-timeline-item color="green">
                  <b>Invoice generated</b>
                  <div style="color: #6b7280">
                    {{ formatDate(order.invoiceResponse.createdAt) }}
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-card>
          </a-col>
        </a-row>
      </div>
      <div
        v-else
        style="
          min-height: 400px;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <!-- Placeholder for loading state -->
      </div>

      <!-- Invoice Details Modal -->
      <a-modal
        :visible="showInvoiceDetailsModal"
        :footer="null"
        @cancel="handleInvoiceDetailsModalClose"
        width="700px"
        :title="`Invoice Details – INV-${
          order && order.invoiceResponse && order.invoiceResponse.id
            ? order.invoiceResponse.id
            : ''
        }`"
      >
        <!-- Header -->
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 16px;
          "
        >
          <div style="display: flex; flex-direction: column; gap: 10px">
            <p>
              <b>Invoice #:</b>
              {{
                order.invoiceResponse && order.invoiceResponse.id
                  ? order.invoiceResponse.id
                  : "N/A"
              }}
            </p>
            <p>
              <b>Issue Date:</b>
              {{
                formatDate(
                  order.invoiceResponse && order.invoiceResponse.createdAt
                    ? order.invoiceResponse.createdAt
                    : null
                )
              }}
            </p>
            <p>
              <b>Due Date:</b>
              {{
                formatDate(
                  order.invoiceResponse && order.invoiceResponse.dueDate
                    ? order.invoiceResponse.dueDate
                    : null
                )
              }}
            </p>
            <div>
              <b style="margin-right: 10px">Status:</b>
                              <StatusTag
                  :status="order.invoiceResponse ? invoiceStatus[order.invoiceResponse.status] : 'Unknown'"
                />
            </div>
          </div>
          <div style="display: flex; flex-direction: column; gap: 10px">
            <p>
              <b>Customer:</b>
              {{ order.invoiceResponse.customerBusinessName }}
            </p>
            <p>
              <b>Billing Address:</b>
              {{ getFullAddress(order.invoiceResponse) }}
            </p>
          </div>
        </div>

        <!-- Line-Item Breakdown -->
        <h3>Line-Item Breakdown</h3>
        <div style="border: 1px solid #e0e0e0; border-radius: 8px">
          <a-table
            :columns="invoiceItemColumns"
            :data-source="order.productDetails"
            :pagination="false"
            :class="'invoice-outer-border'"
            style="margin-bottom: 0"
          />
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 10px;
              margin: 16px;
            "
          >
            <div>
              Subtotal:
              <b>{{ formatAmount(order.invoiceResponse.totalOrderValue) }}</b>
            </div>
            <div>
              Discount:
              <b>{{ formatAmount(order.invoiceResponse.discount) }}</b>
            </div>
            <div>
              Total:
              <b style="color: #26a246"
                >{{ formatAmount(order.invoiceResponse.discountedValue) }}
              </b>
            </div>
          </div>
        </div>

        <!-- Summary -->
        <h3>Summary</h3>
        <div style="display: flex; align-items: flex-start; gap: 64px">
          <div style="display: flex; flex-direction: column; gap: 10px">
            <div>
              Total Amount:
              <b>{{ formatAmount(order.invoiceResponse.discountedValue) }} </b>
            </div>
            <!-- <div>Amount Paid: <b>GHS 0</b></div> -->
            <div>
              Balance Due:
              <b>{{ formatAmount(order.invoiceResponse.discountedValue) }} </b>
            </div>
            <div>Last Payment Date: <b>N/A</b></div>
          </div>
          <div style="display: flex; gap: 10px">
            <div>Factoring Status:</div>
            <StatusTag :status="order.invoiceResponse.factoringstatus" />
          </div>
        </div>

        <!-- Action Buttons -->
        <div
          style="
            margin: 24px 0px;
            display: inline-flex;
            flex-direction: column;
            gap: 10px;
          "
        >
          <a-button
            type="primary"
            icon="download"
            style="background-color: #26a246; border: none; width: 180px"
          >
            Download PDF
          </a-button>
          <a-button
            style="
              color: green;
              border: 1px solid #a7f3d0;
              background-color: #ecfdf5;
              width: 180px;
            "
            type="default"
            icon="thunderbolt"
          >
            Request Factoring
          </a-button>
        </div>
      </a-modal>

      <!-- Complete Order Modal -->
      <a-modal
        :visible="showCompleteOrderModal"
        title="Complete Order"
        @ok="confirmCompleteOrder"
        @cancel="handleCompleteOrderModalClose"
        :confirmLoading="completeOrderLoading"
        okText="Complete Order"
        cancelText="Cancel"
      >
        <p>Are you sure you want to complete this order? This action cannot be undone.</p>
      </a-modal>

      <div style="display: flex; justify-content: flex-start; margin-top: 24px">
        <a-button @click="goBack" class="back-button" :bordered="false">
          <a-icon type="arrow-left" /> Back to Orders
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsHeader from "../DetailsHeader.vue";
import StatusTag from "../../shared-components/StatusTag.vue";
import sellersService from "../../../api/sellers.service";

import {
  DeliveryMethodMap,
  formatAmount,
  formatDate,
  getInitials,
  invoiceStatus,
  orderStatus,
} from "../../../utils";

export default {
  name: "OrderDetails",
  components: {
    DetailsHeader,
    StatusTag,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      order: null,
      loading: true,
      completeOrderLoading: false,
      showInvoiceDetailsModal: false,
      showCompleteOrderModal: false,
      invoiceStatus,
      DeliveryMethodMap,
      productColumns: [
        {
          title: "Product Name",
          dataIndex: "productName",
          key: "productName",
        },
        {
          title: "SKU",
          dataIndex: "sku",
          key: "sku",
          customRender: (text) => text || "N/A",
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
        },
        {
          title: "Unit Price",
          dataIndex: "price",
          key: "price",
          customRender: (price) => `GHS ${price ? price.toFixed(2) : "0.00"}`,
        },
        {
          title: "Discount",
          dataIndex: "discount",
          key: "discount",
          customRender: (text) => `${text || 0}%`,
        },
        {
          title: "Subtotal",
          key: "subtotal",
          customRender: (_, record) =>
            `GHS ${(record.quantity * record.price).toFixed(2)}`,
        },
      ],
      invoiceItemColumns: [
        { title: "SKU ID", key: "sku", customRender: () => "N/A" },
        { title: "Product Name", dataIndex: "productName", key: "productName" },
        { title: "Quantity", dataIndex: "quantity", key: "quantity" },
        {
          title: "Unit Price",
          dataIndex: "price",
          key: "price",
          customRender: (record) => formatAmount(record),
        },
        {
          title: "Line Total",
          key: "lineTotal",
          customRender: (_, record) =>
            formatAmount(record.quantity * record.price),
        },
      ],
    };
  },
  computed: {
    orderDetailsBreadcrumbs() {
      return [
        { text: "Seller Details", to: `/sellers/${this.userId}` },
        { text: "Orders", to: `/sellers/${this.userId}?tab=7` },
        { text: "Order Details", to: null },
      ];
    },
    shouldShowCompleteButton() {
      // Show button only if order status is "Fulfilling" (status 2)
      return this.order && this.order.status === 2;
    },
    orderStatusDisplay() {
      if (!this.order) return '';
      
      // Get the status string from the numeric status value
      const statusString = orderStatus[this.order.status] || 'Unknown';
      

      return statusString;
    },
  },
  methods: {
    async fetchOrderDetails() {
      const response = await sellersService.getSellerOrderDetails(this.orderId);

      console.log("Order details response:", response.data);

      if (response.status == 200) {
        this.order = response.data.data;
        console.log("Order details loaded:", this.order);
      } else {
        this.$message.error("An error occurred while fetching details");
        console.error("No order data in response:", response.data);
      }
      console.log("Order details loaded:");
      this.loading = false;
    },
    formatAmount,
    formatDate,
    getInitials,
    getFullAddress(invoiceResponse) {
      if (!invoiceResponse) return "N/A";
      const { customerAddress, customerCity, customerCountry } =
        invoiceResponse;
      const addressParts = [
        customerAddress,
        customerCity,
        customerCountry,
      ].filter(Boolean);
      return addressParts.length ? addressParts.join(", ") : "N/A";
    },
    viewInvoice() {
      this.showInvoiceDetailsModal = true;
    },
    handleInvoiceDetailsModalClose() {
      this.showInvoiceDetailsModal = false;
    },
    goBack() {
      this.$router.go(-1);
    },
    handleCompleteOrder() {
      // Show the completion confirmation modal
      this.showCompleteOrderModal = true;
    },
    
    async confirmCompleteOrder() {
      this.completeOrderLoading = true;
      
      try {
        // Call API to complete order
        const response = await sellersService.completeOrderFulfillment(this.orderId);
        
        if (response.status === 200) {
          this.$message.success('Order completed successfully!');
          // Refresh order details to show updated status
          await this.fetchOrderDetails();
        } else {
          this.$message.error('Failed to complete order. Please try again.');
        }
      } catch (error) {
        console.error('Error completing order:', error);
        this.$message.error('An error occurred while completing the order. Please try again.');
      } finally {
        this.completeOrderLoading = false;
      }
    },
    
    handleCompleteOrderModalClose() {
      this.showCompleteOrderModal = false;
    }
  },
  created() {
    this.fetchOrderDetails();
  },
};
</script>

<style scoped>
.order-details-container {
  padding: 24px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);
  position: relative;
}

.order-content {
  margin-top: 30px;
}

.avatar {
  background-color: #d1fae5;
  color: #047857;
  font-size: 14px;
  font-weight: bold;
}

p {
  margin: 0;
}

h3 {
  font-size: 16px;
  font-weight: bolder;
  color: #000;
  margin-top: 20px;
}

.back-button {
  background-color: #26a246;
  color: #fafafa;
  border-radius: 6px;
}

.invoice-outer-border .ant-table {
  border: none !important;
}

.invoice-outer-border .ant-table-container {
  border: none !important;
}

.invoice-outer-border .ant-table-content {
  border: none !important;
}

.invoice-outer-border .ant-table-thead > tr > th {
  background: #effff3 !important;
  border-bottom: none !important;
}

.invoice-outer-border .ant-table-tbody > tr > td {
  border: none !important;
}

.invoice-outer-border .ant-table {
  border-radius: 6px !important;
  border: 1px solid #e0e0e0 !important;
}

.ant-table-thead > tr:first-child > th:first-child {
  border-top-left-radius: 10px;
}

.ant-table-thead > tr:first-child > th:last-child {
  border-top-right-radius: 8px;
}
</style>
